export default function TeachingMethods() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="py-16 bg-gradient-to-br from-amber-50 to-yellow-100">
        <div className="max-w-6xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold text-dblue text-center mb-12">
            Our Teaching Methods
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 space-y-8">
          
          {/* Introduction */}
          <div className="bg-blue-50 rounded-lg p-8 border border-blue-100">
            <p className="text-gray-700 leading-relaxed text-lg">
              We believe that the parents and the family are the most important caregivers in the child's life. 
              In maintaining an atmosphere of respect, warmth, predictability, and encouragement, we attempt to 
              create a safe environment where children learn to trust their abilities and extend their limits.
            </p>
          </div>

          {/* We Believe */}
          <div className="bg-white rounded-lg p-8 border border-gray-200 shadow-sm">
            <h2 className="text-2xl font-bold text-dblue mb-6">We believe:</h2>
            <ul className="space-y-3 text-gray-700">
              <li>• Each child is an individual and should be allowed to develop at his/her own pace in a safe, secure and nurturing environment.</li>
              <li>• Children should be treated with respect and should be free to express their feelings.</li>
              <li>• Children learn by exploring the world around them, thus making sense of the world in which they live.</li>
              <li>• In giving children a sense of self confidence and individuality.</li>
              <li>• In inspiring the children to seek out knowledge.</li>
              <li>• In having children learn about their own individual strengths and ideas.</li>
              <li>• In making the centre a fun place where the child looks forward to coming.</li>
              <li>• In developing a community where parents, teachers, staff and children can share information and support each other's development.</li>
            </ul>
          </div>

          {/* Our Educators */}
          <div className="bg-white rounded-lg p-8 border border-gray-200 shadow-sm">
            <h2 className="text-2xl font-bold text-dblue mb-6">Our educators:</h2>
            <ul className="space-y-3 text-gray-700">
              <li>• Are co-creators of the class along with children.</li>
              <li>• Study, play, and learn with the children.</li>
              <li>• Help children form meaningful relationships with the environment around them.</li>
              <li>• Use provocation with children to engage learning.</li>
              <li>• Are always observing and building on their students new interests.</li>
              <li>• Act as facilitator and expands on existing knowledge to help children further their learning.</li>
              <li>• Give uninterrupted time periods for learning.</li>
              <li>• Have readily available documentation, through photographs and children's quotes, for children to see what they have learned.</li>
              <li>• Will have informal conferences with classroom parents throughout the year. In addition, the educator will have two formal conferences in a year with his/her team members (end of January and May). These conferences are to share observations on each child and on the child as a member of the group.</li>
            </ul>
          </div>

          {/* Reggio Emilia Approach */}
          <div className="bg-amber-50 rounded-lg p-8 border border-amber-100">
            <h2 className="text-2xl font-bold text-dblue mb-6">The Reggio Emilia Approach:</h2>
            <ul className="space-y-3 text-gray-700">
              <li>• Gives children a sense of self-confidence and individuality.</li>
              <li>• Inspires children to seek out knowledge and learn about their own individual strengths and ideas.</li>
              <li>• Makes the centre a fun place where the child looks forward to coming.</li>
              <li>• Develops a community where parents, teachers, staff and children can share information and support each other's development.</li>
            </ul>
          </div>

          {/* Reading Program */}
          <div className="bg-green-50 rounded-lg p-8 border border-green-100">
            <h2 className="text-2xl font-bold text-dblue mb-6">Our Reading Program:</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                We use an explicit, systematic phonics program that teaches <strong>"spelling before reading"</strong>. 
                In fact, reading naturally occurs after spelling instruction begins. We understand that our language 
                is phonetic and the children need tools to successfully learn the code, both to read and spell. 
                But reading is not being able to sound out or decode; it is getting meaning from the print and 
                understanding what is being communicated. Therefore, we begin with spelling.
              </p>
              <p>
                The children learn spelling through a unique dictation process. The spelling list then doubles as a 
                reading list and it is with these words that the children practice "sounding out" or "decoding". 
                Once this process becomes largely automated, the children naturally step into reading. There is no 
                need for "basal readers" and "workbooks" as children will be able to begin with "easy readers" found in libraries.
              </p>
              <p>
                We teach everything correctly the first time so that children are not forced to relearn things that 
                have been done incorrectly for a long period of time. We teach from what is known to what is unknown, 
                building <strong>"line upon line and precept upon precept"</strong>. Once the children are reading (and this is not 
                "sounding out" practice, but reading for meaning), the children are put on an individualized reading 
                program according to their ability. Some start reading books early, while others jump in later when they are ready.
              </p>
              <p>
                Grade Two children and above may use novel studies and short stories to deepen their comprehension 
                and thinking skills. Our spelling into reading program then becomes a spelling program successfully 
                teaching spelling and how the English language works.
              </p>
              <p>
                We recognize that we are giving children the <strong>"tools"</strong> to be able to read and spell. 
                Like all tools, children will master their use at various times; some will need more practice than others. 
                But we believe that <strong>all children can learn and be successful</strong> as this multi-sensory 
                approach incorporates all learning styles.
              </p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}


